<template>
  <TransitionGroup
    name="app-notifications"
    tag="ul"
    class="app-notifications list-unstyled"
  >
    <li
      v-for="item in delayedNotifications"
      :key="item.date"
      class="app-notifications__item'"
    >
      <div
        :class="{
          'app-notifications__notification': true,
          [`app-notifications__notification--${item.type}`]: item.type,
        }"
        @click="removeNotification(item)"
      >
        <div
          v-if="item.title"
          class="app-notifications__notification__title"
        >
          {{ item.title }}
        </div>
        <div class="app-notifications__notification__text">
          {{ item.text }}
        </div>
      </div>
    </li>
  </TransitionGroup>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const props = defineProps({
  delay: {
    type: Number,
    default: 3000,
  },
})
const getNotifications = computed(() => store.getters['notifications/getNotifications'])
const removeNotification = (item) => store.dispatch('notifications/removeNotification', item)

const destroyNotification = (item) => {
  clearTimeout(item.timer)
  removeNotification(item)
}

const delayedNotifications = computed(() => {
  return getNotifications.value.map((notification, index) => {
    const delay = notification.delay || props.delay

    return {
      ...notification,
      timer: setTimeout(() => {
        destroyNotification(notification)
      }, delay),
    }
  })
})
</script>

<style lang="scss" scoped>
@import '@variables';

.app-notifications {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 5000;
  width: 18.75rem;
  &__item {
    display: block;
    width: 100%;
    overflow: hidden;
  }
  &__notification {
    box-sizing: border-box;
    display: block;
    padding: 0.625rem;
    margin: 0 0.3125rem 0.3125rem;
    font-size: 0.75rem;
    color: white;
    text-align: left;
    background: $notification-info;
    border-left: 0.3125rem solid $notification-info-dark;

    &__title {
      font-weight: 600;
    }

    &--warn {
      background: $notification-warn;
      border-left-color: $notification-warn-dark;
    }

    &--error {
      background: $notification-error;
      border-left-color: $notification-error-dark;
    }

    &--success {
      background: $notification-success;
      border-left-color: $notification-success-dark;
    }
  }

  &-enter-active,
  &-leave-active {
    transition: all 0.5s;
  }
  &-enter-from,
  &-leave-to {
    opacity: 0;
  }
}
</style>
